<div
  class="action-box d-flex w-100"
  *ngIf="isCollapsed ?? commonService.is_small_screen"
>
  <button
    #menuButton
    type="button"
    id="button-{{ row.field_key }}"
    aria-label="Open actions menu"
    aria-haspopup="true"
    [attr.aria-expanded]="template.isOpen()"
    [ngbPopover]="actionBox"
    triggers="manual"
    #template="ngbPopover"
    placement="right auto"
    [autoClose]="true"
    container="body"
    [popoverClass]="popoverClass"
    class="btn btn-action-menu"
    tabindex="0"
    (click)="template.toggle()"
    (shown)="onPopoverShown()"
    (hidden)="onPopoverHidden()"
  >
    <i class="icon-vert-dots mt-1"></i>
  </button>
  <ng-template #actionBox>
    <ng-container *ngIf="enableAccessibility; else standardContext">
      <div class="popup-actions" role="menu" aria-label="Available actions">
        <ng-container
          *ngTemplateOutlet="
            actionsButton;
            context: {
              row: row,
              rowIndex: rowIndex,
              currentPage: currentPage,
              pageSize: pageSize
            }
          "
        ></ng-container>
      </div></ng-container
    >
    <ng-template #standardContext>
      <div
        class="small-screen-actions"
        role="menu"
        aria-label="Available actions"
      >
        <ng-container
          *ngTemplateOutlet="actionsButton; context: { row: row }"
        ></ng-container>
      </div>
    </ng-template>
  </ng-template>
</div>
